export async function doRequest<T>(url: string, options: RequestInit) {
  const res = await fetch(url, options);

  if (!res.ok) {
    throw new Error('Auth request failed: ' + url);
  }

  return res.json() as T;
}
